<template>
  <section class="wrapper">
    <van-form class="mt10">
      <van-field
        input-align="right"
        v-model="email"
        label="邮箱地址"
        placeholder="请输入邮箱地址"
        :rules="[{ required: true }]"
      />
    </van-form>
    <van-button class="mt10" block round type="primary">完成</van-button>
  </section>
</template>

<script>
  export default {
    data() {
      return {
        email: ''
      }
    }
  }
</script>
